__turbopack_context__.v({
  "RewardRuleContainer": "PopupCoin-module__RKOKAq__RewardRuleContainer",
  "dfx_coinBonusContainer": "PopupCoin-module__RKOKAq__dfx_coinBonusContainer",
  "dfx_coinPopupAlert": "PopupCoin-module__RKOKAq__dfx_coinPopupAlert",
  "dfx_coinPopupBody": "PopupCoin-module__RKOKAq__dfx_coinPopupBody",
  "dfx_coinPopupBox": "PopupCoin-module__RKOKAq__dfx_coinPopupBox",
  "dfx_coinPopupBtn": "PopupCoin-module__RKOKAq__dfx_coinPopupBtn",
  "dfx_coinPopupClaimButton": "PopupCoin-module__RKOKAq__dfx_coinPopupClaimButton",
  "dfx_coinPopupCloseBtn": "PopupCoin-module__RKOKAq__dfx_coinPopupCloseBtn",
  "dfx_coinPopupContainer": "PopupCoin-module__RKOKAq__dfx_coinPopupContainer",
  "dfx_coinPopupContent": "PopupCoin-module__RKOKAq__dfx_coinPopupContent",
  "dfx_coinPopupDesc": "PopupCoin-module__RKOKAq__dfx_coinPopupDesc",
  "dfx_coinPopupIcon": "PopupCoin-module__RKOKAq__dfx_coinPopupIcon",
  "dfx_coinPopupOverlay": "PopupCoin-module__RKOKAq__dfx_coinPopupOverlay",
  "dfx_coinWrapper": "PopupCoin-module__RKOKAq__dfx_coinWrapper",
  "dfx_loginPopup": "PopupCoin-module__RKOKAq__dfx_loginPopup",
  "dfx_loginPopupBox": "PopupCoin-module__RKOKAq__dfx_loginPopupBox",
  "dfx_loginPopupIcon": "PopupCoin-module__RKOKAq__dfx_loginPopupIcon",
});
